import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import BrandLogo from "../../Components/BrandLogo";
import { api, setSession } from "../../lib/api";
import "../Login.css";

const Ar = () => (
  <svg className="ar" viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12M9 3l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function AcceptInvite() {
  const { token } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api(`/invites/${token}`)
      .then((d) => setInvite(d.invite))
      .catch((e) => setError(e.message));
  }, [token]);

  async function submit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!username || password.length < 8) {
      toast({ title: "Username and 8+ char password required", status: "warning" });
      return;
    }
    setSubmitting(true);
    try {
      const data = await api(`/invites/${token}/accept`, {
        method: "POST",
        body: JSON.stringify({ username, password }),
      });
      setSession(data);
      toast({ title: "Account created — welcome", status: "success" });
      navigate("/profile");
    } catch (e2) {
      toast({ title: e2.message, status: "error" });
    } finally {
      setSubmitting(false);
    }
  }

  const Shell = ({ children }) => (
    <div className="dl-root">
      <aside className="dl-aside">
        <div className="dl-aside-top">
          <BrandLogo variant="lockup" size={40} mono />
          <Link to="/" className="dl-back">← Home</Link>
        </div>
        <div className="dl-aside-mid dl-fade-in">
          <div className="dl-eyebrow">You've been invited</div>
          <h2>Join the <em>studio.</em></h2>
          <p>Set up your account and step into the workspace. Your name and password are the only things we need from you today.</p>
        </div>
        <div className="dl-aside-foot">
          <span>v. 1.0 — Mai 2026</span>
          <span>Designed in India</span>
        </div>
      </aside>
      <main className="dl-form-wrap">{children}</main>
    </div>
  );

  if (error) {
    return (
      <Shell>
        <div className="dl-form">
          <div className="dl-form-eyebrow">— Error</div>
          <h1>Invite <em>unavailable.</em></h1>
          <p className="dl-sub">{error}</p>
          <Link to="/login" className="dl-cta" style={{ textAlign: "center" }}>
            Go to Sign In <Ar />
          </Link>
        </div>
      </Shell>
    );
  }

  if (!invite) {
    return (
      <Shell>
        <div className="dl-form">
          <div className="dl-form-eyebrow">Loading…</div>
          <h1 style={{ opacity: 0.5 }}>One <em>moment.</em></h1>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <form className="dl-form" onSubmit={submit}>
        <div className="dl-form-eyebrow dl-fade-in">— Create account</div>
        <h1 className="dl-fade-in d2">
          Welcome <em>aboard.</em>
        </h1>
        <p className="dl-sub dl-fade-in d2">
          Invited as <strong>{invite.email}</strong>
          {invite.role ? <> · <span style={{ color: "var(--accent-on-light)" }}>{invite.role}</span></> : null}
          {invite.team?.name ? <> · {invite.team.name}</> : null}
        </p>

        <div className="dl-field dl-fade-in d3">
          <label className="dl-label">Full name</label>
          <input
            className="dl-input"
            placeholder="Your name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="dl-field dl-fade-in d3">
          <label className="dl-label">Choose a password</label>
          <input
            className="dl-input"
            type="password"
            placeholder="8+ characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button type="submit" className="dl-cta dl-fade-in d4" disabled={submitting}>
          {submitting ? "Creating…" : "Create Account"} <Ar />
        </button>
      </form>
    </Shell>
  );
}
